/**
 * 通用 models
 */

export namespace General {

    /**
     * 通用 API 回傳 model
     */
    export class APIResult<T> {

        Data!: T;
        Code: number = 0;
        Success!: boolean;
        Message: string = '';
        Count: number = 0;
    }
}